module.exports = __webpack_public_path__ + "img/photo-0108.ed6bb9a8.jpg";